import { UiComponentsModule } from '@mwe/ui/components';

import { Component, computed, inject } from '@angular/core';
import { MeterPointChangeSignalState } from '../../../meterpoint-change-request.types';
import { SignalState } from '@shared-ikp/service/signal-state-service/signal-state.service';
import { getAddressPostCodeAndStreetFormatted } from '@mwe/utils';

@Component({
  selector: 'ikp-invoicing-information',
  imports: [UiComponentsModule],
  templateUrl: './invoicing-information.component.html',
  styleUrl: './invoicing-information.component.scss',
  standalone: true,
})
export class InvoicingInformationComponent {
  protected wizardStore: MeterPointChangeSignalState = inject(SignalState);
  protected invoicingAddress = computed(() => getAddressPostCodeAndStreetFormatted(this.wizardStore.state().meterPoint.adresse));
}
